<span class="nc-icon-glyph spin loader_refresh x3"></span>
<p *ngIf="message">{{message}}</p>
